import React from 'react';
import { useTranslation } from 'react-i18next';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import {
    ALL_CLIENT_APPLICATIONS,
} from '../../graphql/settings';
import Spinner from '../Spinner';
import Error from '../errors/Error';
import ClientApplicationsDetailTab from './ClientApplicationsDetailTab';

function ClientApplicationsDetail() {
    const { t } = useTranslation();
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(ALL_CLIENT_APPLICATIONS);
    let result;
    if (loading) {
        result = <Spinner className="client-applications-loading" />;
    } else if (error) {
        result = <Error className="client-applications-error" error={error} />;
    } else if (data.allClientApplications === null) {
        result = <div className="amqp-not-configured">{t('settings.amqp-not-configured')}</div>;
    } else {
        result = (
            <ClientApplicationsDetailTab
                clientApplications={data.allClientApplications}
            />
        );
    }
    return result;
}

export default ClientApplicationsDetail;
